import { useEffect } from 'react';

/**
 * Hook que detecta clics fuera de un elemento referenciado.
 * @param {React.RefObject} ref - La referencia al elemento a vigilar.
 * @param {Function} handler - La función a ejecutar cuando se hace clic fuera.
 */
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useClickOutside;